<template>
    <div v-for="modulo in modulosfotos" :key="modulo.idChecklistModulo">
        <div class="card flex-container my-4">
            <div class="flex gap-2">
                <h3 class="font-semibold">Fotos Checklist {{ modulo.nome }}</h3>
            </div>
            <FotoResumo :tiposFotos="modulo.fotos" />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import FotoResumo from '@/common/foto/components/FotoResumo.vue';
import ComponenteFotoConfirmacaoService from '@/services/componentes/ComponenteFotoConfirmacaoService';

/* eslint-disable vue/no-setup-props-destructure */
export default defineComponent({
    name: 'FotoConfirmacao',
    components: {
        FotoResumo,
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    setup(props) {
        return ComponenteFotoConfirmacaoService.setup(props)
    }
});
</script>